import React, { useState, useEffect } from "react";
import { Input } from "@commonsku/styles";
import { formatMoney } from "../../../utils";
import { createErrorPopup } from "../../../actions/popup";
import { useDispatch } from "react-redux";

interface MetadataAdjustmentProps {
  option?: string;
  metadataId: string;
  adjustment?: string;
  parentId: string;
  itemRetailAdjustmentId?: string;
  onUpdateRetailAdjustment: (
    item_retail_adjustment_id: string,
    selector: string,
    prevValue: any,
    newValue: string
  ) => void;
  onAddRetailAdjustment: (
    item_id: string,
    selector: string,
    value: {
      metadata_id: string;
      option?: string;
      adjustment: string;
    }
  ) => void;
}

const MetadataAdjustment: React.FC<MetadataAdjustmentProps> = ({
  option,
  metadataId,
  adjustment,
  parentId,
  itemRetailAdjustmentId,
  onUpdateRetailAdjustment,
  onAddRetailAdjustment,
}) => {
  const [adjustmentValue, setAdjustmentValue] = useState<string>(adjustment ?? "");
  const numberValue = Number(adjustmentValue);
  const isValid = adjustmentValue === "" || (!Number.isNaN(numberValue) && Number.isFinite(numberValue));

  useEffect(() => {
    setAdjustmentValue(adjustment ?? "");
  }, [adjustment]);

  const dispatch = useDispatch();
  const showError = (message: string) => dispatch(createErrorPopup(message));

  const handleBlur = () => {
    if (isValid) {
      const fixedDecimalNumberValue = formatMoney(numberValue, 2);
      setAdjustmentValue(fixedDecimalNumberValue);

      if (itemRetailAdjustmentId) {
        onUpdateRetailAdjustment(itemRetailAdjustmentId, "adjustment", adjustment ?? null, fixedDecimalNumberValue);
      } else {
        if (option === "") {
          showError("Option value must be set before setting upcharge.");
          setAdjustmentValue("");
          return;
        }
        onAddRetailAdjustment(parentId, "metadata", {
          metadata_id: metadataId,
          adjustment: fixedDecimalNumberValue,
          ...(option ? { option } : {}),
        });
      }
    }
  };

  return (
    <Input
      type="text"
      inputMode="decimal"
      value={adjustmentValue}
      error={!isValid}
      style={{ margin: 0 }}
      onFocus={e => e.target.select()}
      onChange={(e) => {
        const val = e.target.value.replace(/[^0-9.]/g, "");
        setAdjustmentValue(val);
      }}
      onBlur={handleBlur}
      data-test-id={`metadata-upcharge-adjustment-${itemRetailAdjustmentId}`}
    />
  );
};

export default MetadataAdjustment;
